<template>
  <router-view />
</template>

<script>
import { unRegisterMixin } from '@/mixin/storeGenerator';

export default {
  name: 'WrapperBookManagement',
  mixins: [unRegisterMixin],
  data() {
    return {
      moduleName: 'BookManagementModule',
    };
  },
};
</script>
